import { type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { from, switchMap } from 'rxjs';

import { environment } from '../../../environments/environment';

function isApiRequest(url: string): boolean {
  const requestUrl = new URL(url, globalThis.location.origin);
  const apiUrl = new URL(environment.apiUrl, `${globalThis.location.origin}/`);
  const apiPath = apiUrl.pathname.replace(/\/$/, '');

  return (
    requestUrl.origin === apiUrl.origin &&
    (requestUrl.pathname === apiPath || requestUrl.pathname.startsWith(`${apiPath}/`))
  );
}

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  if (!isApiRequest(request.url)) {
    return next(request);
  }

  const oktaAuth = inject(OKTA_AUTH);
  return from(oktaAuth.getOrRenewAccessToken()).pipe(
    switchMap((accessToken) =>
      next(
        accessToken
          ? request.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
          : request,
      ),
    ),
  );
};
